import { computed, inject, Injectable, resource } from '@angular/core';
import { APIService } from './APIService/api.service';
import { ifNotError } from '../misc/compositions';

@Injectable({
  providedIn: 'root',
})
export class FkColorsState {
  private readonly api = inject(APIService);

  private readonly colorsResource = resource({
    loader: () => this.api.getFKColors(),
    defaultValue: [],
  });

  public readonly fkColorsMap = ifNotError(this.colorsResource);

  public fromFK(fk: number): string {
    return this.fkColorsMap()[fk] || '#FFFFFF00';
  }
  public reload() {
    this.colorsResource.reload();
  }
}
